import { AppThunk } from '../../../store/rootReducer';
import {
  codesToAddToAssessSelector,
  codesToRemoveToAssessSelector,
  labelsToAddSelector,
  labelsToRemoveSelector,
} from '../selectors/auto-labels.selectors';
import * as autoLabelsActions from '../actions/auto-labels.actions';

export const updateAutoLabelsToAssess =
  (): AppThunk => (dispatch, getState) => {
    const codesToAddToAssess = codesToAddToAssessSelector(getState());
    const codesToRemoveToAssess = codesToRemoveToAssessSelector(getState());
    const labelsToAdd = labelsToAddSelector(getState());
    const labelsToRemove = labelsToRemoveSelector(getState());
    const newCodesToAddToAssess = new Set(codesToAddToAssess);
    const newCodesToRemoveToAssess = new Set(codesToRemoveToAssess);
    const codesToAddAlreadyDisplayed = new Set(
      labelsToAdd.map((label) => label.code),
    );
    const codesToRemoveAlreadyDisplayed = new Set(
      labelsToRemove.map((label) => label.code),
    );

    // on both ToAdd and ToRemove, we want to keep the status of the labels that are already displayed
    // labelsToAdd and labelsToRemove are the labels that are displayed on the suggestion panel
    dispatch(
      autoLabelsActions.setAutoLabels({
        labelsToAdd: [
          // remove the labels that are already displayed but not triggered anymore
          ...labelsToAdd.filter((label) =>
            newCodesToAddToAssess.has(label.code),
          ),
          // add the labels that are triggered but not displayed yet
          ...codesToAddToAssess
            .filter((code) => !codesToAddAlreadyDisplayed.has(code))
            .map((code) => ({
              code,
              status: false,
            })),
        ],
        labelsToRemove: [
          // remove the labels that are already displayed but not triggered anymore
          ...labelsToRemove.filter((label) =>
            newCodesToRemoveToAssess.has(label.code),
          ),
          // add the labels that are triggered but not displayed yet
          ...codesToRemoveToAssess
            .filter((code) => !codesToRemoveAlreadyDisplayed.has(code))
            .map((code) => ({
              code,
              status: false,
            })),
        ],
        meta: { history: false },
      }),
    );
  };
